import React, { useState, useEffect } from "react";
import {
  Card,
  CardContent,
  Grid,
  Stack,
  Typography,
  Paper,
  Box,
  Button,
  Link,
  Avatar,
  Badge,
  IconButton,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { styled } from "@mui/material/styles";
import jwt_decode from "jwt-decode";
import { BASE_URL } from "../../../constant/apiURL";
import clsx from "clsx";
import { useNavigate } from "react-router-dom";
import ApiEndpoints from "../../../utils/ApiEndpoints";
import { apiGet, apiPut } from "../../../utils/apiRequests";
import { PhotoCamera } from "@mui/icons-material";
import { toast } from "react-toastify";

const cardBG = require("../../../assets/images/handicap-card-bg.png");
const cardIMG = require("../../../assets/images/user_placeholder.png");
const editIcon = require("../../../assets/images/edit.png");
const playerIconWhite = require("../../../assets/images/player-white.png");
const playerIconBlack = require("../../../assets/images/player-black.png");
const playerImg = require("../../../assets/images/profile_img.png");

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    backgroundColor: "#fff",
    width: "20px",
    height: "20px",
    borderRadius: "50%",
  },
}));

const useStyles = makeStyles({
  cardMain: {
    backgroundImage: `url(${cardBG})`,
    // backgroundRepeat: 'no-repeat',
    // backgroundSize: 'cover',
    display: "flex",
    maxWidth: "100%",
    backgroundColor: "",
  },
  cardImg: {
    width: "40%",
    borderRadius: 70,
  },
  rankingBox: {
    backgroundColor: "#FFF",
    borderRadius: 10,
    border: "2px solid #06623b",
    padding: 20,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    marginBottom: "20px",
    paddingTop: "30px",
  },
  blueBox: {
    backgroundColor: "#0C2DD8",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    // padding: 8,
    borderRadius: 10,
  },
  whiteBox: {
    backgroundColor: "#F0F0F4",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    // padding: 8,
    borderRadius: 10,
  },
  yellowBox: {
    backgroundColor: "#FFC700 !important",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    // padding: 8,
    borderRadius: 10,
  },

  playerprofilebtn: {
    backgroundColor: "#06623B !important",
    color: "#FFF !important",
    border: "1px solid #ccc !important",
    borderRadius: "5px !important",
    padding: "12px 22px !important",
    fontSize: "12px !important",
    fontWeight: "400 !important",
  },
  editIcon: {
    width: 22,
    height: 22,
    position: "absolute",
    top: 47,
    right: 42,
    cursor: "pointer",
  },
  contactLinks: {
    fontSize: "0.86em",
    "&:hover": {
      color: "#FFF",
    },
  },
  userImage: {
    height: "100px !important",
    width: "100px !important",
    "& > img": {
      height: "100px !important",
      width: "100px !important",
    },
  },
});

const SmallAvatar = styled(Avatar)(({ theme }) => ({
  width: 22,
  height: 22,
  border: `2px solid ${theme.palette.background.paper}`,
}));
function HandicapCard(props) {
  const classes = useStyles();

  const userInfo = props.userInfo;

  const navigate = useNavigate();

  const [playerData, setPlayerData] = useState();
  const [profileImgPreview, setProfileImgPreview] = useState(null);
  const [file, setFile] = useState(null);
  const [isFromDashboard, setIsFromDashboard] = useState(true);

  const getPlayerDetails = () => {
    apiGet(
      `${ApiEndpoints.user.base}/basic-info`,
      (res) => {
        setPlayerData(res?.data);
      },
      (err) => console.log("getPlayerDetails Error: ", err.message)
    );
  };

  const changeProfile = (e) => {
    if (!e.target.files || e.target.files.length === 0) {
      return setFile(null);
    }

    const imageMimeType = /image\/(png|jpg|jpeg)/i;

    let _file = e.target.files[0];

    if (!_file.type.match(imageMimeType)) {
      return toast.error("Image type is not valid");
    }

    let formData = new FormData();

    formData.append("file", _file);

    setFile(_file);

    apiPut(`${ApiEndpoints.user.uploadImage}`, formData, (res) => {
      if (res.error) {
        toast.error(res?.message);
      } else {
        toast.success("Profile Image Uploaded Successfully");
      }
    });
  };

  useEffect(() => {
    let fileReader,
      isCancel = false;

    if (file) {
      fileReader = new FileReader();

      fileReader.onload = (e) => {
        const { result } = e.target;

        if (result && !isCancel) {
          setProfileImgPreview(result);
        }
      };

      fileReader.readAsDataURL(file);
    }

    return () => {
      isCancel = true;
      if (fileReader && fileReader.readyState === 1) {
        fileReader.abort();
      }
    };
  }, [file]);

  useEffect(() => {
    getPlayerDetails();
  }, []);

  const token = localStorage.getItem("token");
  var decodedToken = jwt_decode(token);

  const _handleClickPlayerProfile = () => {
    navigate(`/player-profile/${decodedToken?.id}`, {
      state: { isFromDashboard: isFromDashboard },
    });
  };

  return (
    <Card className={classes.cardMain}>
      <CardContent>
        <Grid container>
          <Grid
            item
            container
            sx={{ margin: "10px !important", mb: "7%", display: "flex", ml: 6 }}
          >
            <Grid
              item
              xs={12}
              md={4}
              sx={{
                position: "relative",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <StyledBadge
                overlap="circular"
                anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                badgeContent={
                  <IconButton
                    color="primary"
                    aria-label="upload picture"
                    component="label"
                    onChange={changeProfile}
                  >
                    <input hidden accept="image/*" type="file" />
                    <SmallAvatar alt="edit icon" src={editIcon} />
                  </IconButton>
                }
              >
                <Avatar
                  alt={`${userInfo?.first_name} ${userInfo?.last_name}`}
                  src={
                    profileImgPreview === null
                      ? `${BASE_URL}${userInfo?.image}`
                      : profileImgPreview
                  }
                  className={classes.userImage}
                >
                  {`${userInfo?.first_name[0]} ${userInfo?.last_name[0]}`}
                </Avatar>
              </StyledBadge>
            </Grid>
            <Grid
              item
              xs={12}
              md={8}
              container
              alignItems="center"
              justifyContent={{ xs: "center", md: "left" }}
              sx={{ paddingLeft: "9px" }}
            >
              <Box
                textAlign={{ xs: "center", md: "left" }}
                marginTop={{ xs: "10px", md: 0 }}
              >
                <Typography fontWeight={700} color="#fff" variant="body1">
                  {userInfo?.first_name} {userInfo?.last_name}
                </Typography>
                <Typography
                  fontWeight={400}
                  color="#fff"
                  variant="caption"
                  component="h1"
                >
                  {userInfo?.email}
                </Typography>
                <Typography
                  fontWeight={400}
                  color="#fff"
                  variant="caption"
                  component="h1"
                >
                  {userInfo?.mobile_no}
                </Typography>
              </Box>
            </Grid>
          </Grid>

          <Grid
            item
            container
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginTop: "50px",
            }}
          >
            <Grid item container className={classes.rankingBox} xs={11}>
              <Grid
                item
                container
                xs={12}
                spacing={-1}
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Grid item md={12} lg={6} xl={6}>
                  <Typography
                    sx={{
                      textTransform: "uppercase",
                      height: "fit-content !important",
                      lineHeight: 0.8,
                      fontSize: "18px",
                    }}
                    variant="h6"
                    fontWeight={400}
                    color="#000000"
                  >
                    Handicap
                  </Typography>
                  <Typography
                    variant="caption"
                    fontWeight={400}
                    color="#000000"
                    gutterBottom
                    sx={{ fontSize: "12px" }}
                  >
                    WHS index
                  </Typography>
                </Grid>
                <Grid
                  item
                  md={12}
                  lg={6}
                  xl={6}
                  container
                  justifyContent="flex-end"
                >
                  <Typography
                    sx={{ width: "fit-content", fontSize: "22px" }}
                    fontWeight={400}
                    variant="h5"
                    color="#000000"
                    gutterBottom
                  >
                    {userInfo?.handicap ? userInfo?.handicap : 0}
                  </Typography>
                </Grid>
              </Grid>
              <Grid item container sx={{ marginY: "20px" }}>
                <Grid item xs={12}>
                  <Stack spacing={1.6}>
                    {userInfo?.user_tee.map((tee, index) => {
                      return (
                        <Grid
                          container
                          key={index}
                          alignItems="center"
                          sx={{
                            backgroundColor:
                              tee.tee_color.toLowerCase() === "white"
                                ? "#F0F0F4"
                                : tee.tee_color.toLowerCase() === "yellow"
                                ? "#FFC700"
                                : tee.tee_color.toLowerCase() === "black"
                                ? "#000000"
                                : tee.tee_color.toLowerCase(),
                            padding: "16px 25px",
                            borderRadius: "10px",
                          }}
                        >
                          <Grid item xs={1.5}>
                            <img
                              src={
                                tee.tee_color.toLowerCase() === "blue" ||
                                tee.tee_color.toLowerCase() === "yellow" ||
                                tee.tee_color.toLowerCase() === "black"
                                  ? playerIconWhite
                                  : playerIconBlack
                              }
                              width={"55%"}
                              alt={tee.tee_color}
                            />
                          </Grid>
                          <Grid item xs={8.5}>
                            <Typography
                              sx={{
                                fontSize: "15px",
                                fontWeight: "700",
                                textTransform: "capitalize",
                                color:
                                  tee.tee_color.toLowerCase() === "blue" ||
                                  tee.tee_color.toLowerCase() === "yellow" ||
                                  tee.tee_color.toLowerCase() === "black"
                                    ? "#fff"
                                    : "#000",
                              }}
                              color={"#000000"}
                            >
                              {tee.tee_color}
                            </Typography>
                          </Grid>
                          <Grid item xs={2}>
                            <Typography
                              sx={{
                                fontSize: "20px",
                                fontWeight: "400",
                                marginRight: 5,
                                textAlign: "end",
                                width: "100%",
                                color:
                                  tee.tee_color.toLowerCase() === "blue" ||
                                  tee.tee_color.toLowerCase() === "yellow" ||
                                  tee.tee_color.toLowerCase() === "black"
                                    ? "#fff"
                                    : "#000",
                              }}
                            >
                              {tee.handicap_value}
                            </Typography>
                          </Grid>
                        </Grid>
                      );
                    })}
                    <Grid
                      item
                      container
                      xs={12}
                      alignItems="center"
                      sx={{
                        marginTop: "10px !important",
                        height: "fit-content",
                      }}
                    >
                      <Grid item xs={8} paddingX="20px">
                        <Typography
                          sx={{
                            textTransform: "uppercase",
                            height: "fit-content",
                            fontSize: "12px",
                          }}
                          variant="caption"
                          fontWeight={400}
                          color="#000000"
                        >
                          your poty ranking
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        xs={4}
                        container
                        justifyContent="flex-end"
                        paddingX="20px"
                      >
                        <Typography
                          sx={{
                            fontSize: "24px",
                          }}
                          fontWeight={400}
                          variant="h5"
                          color="#000000"
                        >
                          {userInfo?.poty_rank}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Stack>
                </Grid>
              </Grid>
            </Grid>
          </Grid>

          <Grid item container>
            <Grid
              item
              xs={11.5}
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "10px",
              }}
            >
              <Button
                variant="outlined"
                className={classes.playerprofilebtn}
                onClick={_handleClickPlayerProfile}
              >
                View Players Profile
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
}

export default HandicapCard;
